<div class="qb">

  <header class="qb__header">
    <div>
      <h1 class="qb__title">
        <i class="fa-solid fa-layer-group qb__title-icon" aria-hidden="true"></i>
        {{ 'QUESTION_BANK.TITLE' | translate }}
      </h1>
      <p class="qb__subtitle">{{ 'QUESTION_BANK.SUBTITLE' | translate }}</p>
    </div>

    <div class="qb__header-actions">
      @if (!errored() && total() > 0) {
        <span class="qb__total">
          {{ 'QUESTION_BANK.PAGINATION.TOTAL' | translate: { count: total() } }}
        </span>
      }

      <button type="button" class="btn btn-outline-primary" (click)="createQuestion()">
        <i class="fa-solid fa-plus" aria-hidden="true"></i>
        {{ 'QUESTION_BANK.CREATE' | translate }}
      </button>

      <button type="button" class="btn btn-outline-primary" (click)="importReference()">
        <i class="fa-solid fa-file-import" aria-hidden="true"></i>
        {{ 'QUESTION_BANK.IMPORT' | translate }}
      </button>

      <button type="button" class="btn btn-primary" (click)="composeTest()">
        <i class="fa-solid fa-file-pen" aria-hidden="true"></i>
        {{ 'QUESTION_BANK.COMPOSE_TEST' | translate }}
      </button>
    </div>
  </header>

  <app-question-filters
    [value]="criteria()"
    [learningPaths]="learningPaths()"
    [subjects]="subjects()"
    [themes]="themes()"
    [taxonomyErrored]="taxonomyErrored()"
    (valueChange)="onCriteriaChange($event)"
    (reloadTaxonomy)="reloadTaxonomy()">
  </app-question-filters>

  <!-- Échec de la requête : on le dit, avec un moyen de réessayer.
       Aucune donnée n'est affichée à la place. -->
  @if (errored()) {
    <app-error-state
      titleKey="QUESTION_BANK.ERROR_TITLE"
      messageKey="QUESTION_BANK.ERROR_MESSAGE"
      [detail]="errorDetail()"
      (retry)="retry()">
    </app-error-state>
  } @else {

    <!-- Table : défile dans son propre conteneur, la page ne bouge pas. -->
    @if (!isEmpty()) {
    <!-- La facette. « Actives » par defaut, exception assumee au principe
         « tout » : l'etat supprime n'est pas une facette metier, et ouvrir
         sur la corbeille ferait recompter des questions retirees. -->
    <div class="qb__vues" role="group" [attr.aria-label]="'QUESTION_BANK.VIEW' | translate">
      <button type="button" class="qb__vue"
              [attr.aria-pressed]="vue() === 'actives'"
              (click)="changerVue('actives')">
        {{ 'QUESTION_BANK.VIEW_ACTIVE' | translate }}
      </button>
      <button type="button" class="qb__vue"
              [attr.aria-pressed]="vue() === 'corbeille'"
              (click)="changerVue('corbeille')">
        <i class="fa-solid fa-trash-can" aria-hidden="true"></i>
        {{ 'QUESTION_BANK.VIEW_TRASH' | translate }}
      </button>
    </div>

    <!-- La barre n'apparait qu'avec une selection : un bandeau permanent
         occuperait la place sans rien proposer. -->
    @if (selectionCount() > 0) {
      <div class="qb__actions-lot" role="status" aria-live="polite">
        <span class="qb__lot-compte">
          {{ 'QUESTION_BANK.SELECTED' | translate: { count: selectionCount() } }}
        </span>

        @if (vue() === 'actives') {
          <button type="button" class="qb__lot-bt qb__lot-bt--danger"
                  [disabled]="operation()" (click)="mettreALaCorbeille()">
            <i class="fa-solid fa-trash-can" aria-hidden="true"></i>
            {{ 'QUESTION_BANK.TRASH_ACTION' | translate }}
          </button>
        } @else {
          <button type="button" class="qb__lot-bt"
                  [disabled]="operation()" (click)="restaurer()">
            <i class="fa-solid fa-rotate-left" aria-hidden="true"></i>
            {{ 'QUESTION_BANK.RESTORE_ACTION' | translate }}
          </button>
          <button type="button" class="qb__lot-bt qb__lot-bt--danger"
                  [disabled]="operation()" (click)="viderLaCorbeille()">
            <i class="fa-solid fa-fire" aria-hidden="true"></i>
            {{ 'QUESTION_BANK.PURGE_ACTION' | translate }}
          </button>
        }
      </div>
    }

    <div class="qb__table-wrap">
      <table class="qb__table">
        <thead>
          <tr>
            <th scope="col" class="qb__th qb__th--select">
              <input type="checkbox" class="qb__case"
                     [checked]="toutSelectionne()"
                     [attr.aria-label]="'QUESTION_BANK.SELECT_ALL' | translate"
                     (change)="basculerTout()" />
            </th>
            <th scope="col" class="qb__th qb__th--sortable"
                [class.is-active]="isSortedBy('title')"
                (click)="onSort('title')">
              <button type="button" class="qb__sort"
                      [attr.aria-label]="sortAriaKey('title') | translate">
                {{ 'QUESTION_BANK.COLUMNS.TITLE' | translate }}
                <i [class]="'fa-solid ' + sortIcon('title')" aria-hidden="true"></i>
              </button>
            </th>

            <th scope="col" class="qb__th">{{ 'QUESTION_BANK.COLUMNS.TYPE' | translate }}</th>

            <th scope="col" class="qb__th qb__th--sortable"
                [class.is-active]="isSortedBy('difficulty')"
                (click)="onSort('difficulty')">
              <button type="button" class="qb__sort"
                      [attr.aria-label]="sortAriaKey('difficulty') | translate">
                {{ 'QUESTION_BANK.COLUMNS.DIFFICULTY' | translate }}
                <i [class]="'fa-solid ' + sortIcon('difficulty')" aria-hidden="true"></i>
              </button>
            </th>

            <th scope="col" class="qb__th qb__th--sortable qb__th--num"
                [class.is-active]="isSortedBy('points')"
                (click)="onSort('points')">
              <button type="button" class="qb__sort"
                      [attr.aria-label]="sortAriaKey('points') | translate">
                {{ 'QUESTION_BANK.COLUMNS.POINTS' | translate }}
                <i [class]="'fa-solid ' + sortIcon('points')" aria-hidden="true"></i>
              </button>
            </th>

            <th scope="col" class="qb__th qb__th--sortable"
                [class.is-active]="isSortedBy('status')"
                (click)="onSort('status')">
              <button type="button" class="qb__sort"
                      [attr.aria-label]="sortAriaKey('status') | translate">
                {{ 'QUESTION_BANK.COLUMNS.STATUS' | translate }}
                <i [class]="'fa-solid ' + sortIcon('status')" aria-hidden="true"></i>
              </button>
            </th>

            <th scope="col" class="qb__th">{{ 'QUESTION_BANK.COLUMNS.ORIGIN' | translate }}</th>
            <th scope="col" class="qb__th qb__th--num">{{ 'QUESTION_BANK.COLUMNS.VERSION' | translate }}</th>
            <th scope="col" class="qb__th">{{ 'QUESTION_BANK.COLUMNS.THEME' | translate }}</th>

            <th scope="col" class="qb__th qb__th--sortable"
                [class.is-active]="isSortedBy('createdAt')"
                (click)="onSort('createdAt')">
              <button type="button" class="qb__sort"
                      [attr.aria-label]="sortAriaKey('createdAt') | translate">
                {{ 'QUESTION_BANK.COLUMNS.CREATED_AT' | translate }}
                <i [class]="'fa-solid ' + sortIcon('createdAt')" aria-hidden="true"></i>
              </button>
            </th>

            <th scope="col" class="qb__th qb__th--actions">
              {{ 'QUESTION_BANK.COLUMNS.ACTIONS' | translate }}
            </th>
          </tr>
        </thead>

        <tbody>
          @if (loading()) {
            <!-- Squelette : la table garde sa forme pendant le chargement. -->
            @for (row of skeletonRows; track row) {
              <tr class="qb__skel-row" aria-hidden="true">
                @for (cell of skeletonCells; track cell) {
                  <td class="qb__skel-cell"><span class="qb__skel-bar"></span></td>
                }
              </tr>
            }
          } @else {
            @for (question of affichees(); track question.id) {
              <tr app-question-row
                  [item]="question"
                  [selectable]="true"
                  [selected]="estSelectionnee(question.id)"
                  (selectedChange)="basculerSelection(question.id)"
                  (edit)="editQuestion($event)"
                  (remove)="deleteQuestion($event)"></tr>
            }
          }
        </tbody>
      </table>
    </div>
    }

    <!-- Requête réussie mais sans résultat : état vide, pas de liste de repli. -->
    @if (isEmpty()) {
      <app-empty-state
        icon="folder-open"
        titleKey="QUESTION_BANK.EMPTY_TITLE"
        messageKey="QUESTION_BANK.EMPTY_MESSAGE">
      </app-empty-state>
    }

    <!-- Pagination serveur -->
    @if (!isEmpty()) {
      <nav class="qb__pager" [attr.aria-label]="'QUESTION_BANK.PAGINATION.LABEL' | translate">
        <label class="qb__page-size">
          <span>{{ 'QUESTION_BANK.PAGINATION.PAGE_SIZE' | translate }}</span>
          <select [value]="criteria().pageSize ?? pageSizes[0]"
                  [disabled]="loading()"
                  (change)="onPageSize($any($event.target).value)">
            @for (size of pageSizes; track size) {
              <option [value]="size">{{ size }}</option>
            }
          </select>
        </label>

        <div class="qb__pager-nav">
          <button type="button" class="qb__pager-btn"
                  [disabled]="!canPrevious()"
                  (click)="previousPage()">
            <i class="fa-solid fa-chevron-left qb__chev" aria-hidden="true"></i>
            {{ 'QUESTION_BANK.PAGINATION.PREVIOUS' | translate }}
          </button>

          <span class="qb__pager-state">
            {{ 'QUESTION_BANK.PAGINATION.PAGE_OF' | translate:
               { current: currentPage(), total: totalPages() } }}
          </span>

          <button type="button" class="qb__pager-btn"
                  [disabled]="!canNext()"
                  (click)="nextPage()">
            {{ 'QUESTION_BANK.PAGINATION.NEXT' | translate }}
            <i class="fa-solid fa-chevron-right qb__chev" aria-hidden="true"></i>
          </button>
        </div>
      </nav>
    }
  }

</div>
